import { render, staticRenderFns } from "./base-button.vue?vue&type=template&id=2d56984a&scoped=true"
import script from "./base-button.vue?vue&type=script&lang=js"
export * from "./base-button.vue?vue&type=script&lang=js"
import style0 from "./base-button.vue?vue&type=style&index=0&id=2d56984a&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d56984a",
  null
  
)

export default component.exports